import { Typography } from '@interstate/components/Typography';
import { Button } from '@interstate/components/Button';
import { TrashIcon } from '@interstate/components/Icons';
import { type ReactNode } from 'react';
import { LayoutHeaderRow } from './HousingAndEmploymentInfo.style';

type CustomerFieldsLayoutHeaderProps = {
    children: ReactNode;
    onDelete?: () => void;
    deleteTestId?: string;
    disabled?: boolean;
};

export const CustomerFieldsLayoutHeader = ({ children, onDelete, deleteTestId, disabled }: CustomerFieldsLayoutHeaderProps) => {
    return (
        <LayoutHeaderRow>
            <Typography variant="h6">{children}</Typography>
            {onDelete && (
                <Button
                    size="sm"
                    buttonStyle="secondary"
                    sx={{ minWidth: '2rem' }}
                    onClick={onDelete}
                    disabled={disabled}
                    data-testid={deleteTestId}
                >
                    <TrashIcon />
                </Button>
            )}
        </LayoutHeaderRow>
    );
};
